<template>
	<field v-bind="{name, test, error, tooltip, required}">
		<component :is="comp" v-bind="[props, {value}]" @update="update($event)"/>
		<div class="description" v-if="description" v-text="description"/>
	</field>
</template>

<script>
import field from "@/components/order/fields/index.vue";

export default {
	components: {field},
	props: {
		value: {required: true},
		name: {type: String, required: true},
		test: {type: Object,required: false},
		props: {type: Object, required: false},
		tooltip: {type: Object, required: false},
		required: {type: Boolean, required: false},
		description: {type: String, required: false},
	},
	computed: {
		error: (t) => (t.required ? !t.value : false) || (t.test ? !t.test.func(t.value) : false),
		comp: (t) => () => import(/* webpackMode: "eager" */ `@/components/order/fields/${t.props.type}.vue`)
	},
	methods: {
		update(value) {
			this.$emit("input", value);
		}
	}
};
</script>

<style lang="scss" scoped>
.field {
	
	.description {
		margin-top: 1em;
		font-size: 0.75em;
	}
}
</style>
